import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=4c31f990&scoped=true&"
import script from "./AppHeader.vue?vue&type=script&lang=js&"
export * from "./AppHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=4c31f990&prod&lang=css&"
import style1 from "./AppHeader.vue?vue&type=style&index=1&id=4c31f990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c31f990",
  null
  
)

export default component.exports